import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'clients_json';

const mockClients = [
  {
    id: '1',
    name: 'Ahmed Saeed',
    phone: '0500000001',
    type: 'جملة',
    visitDays: ['Sunday', 'Wednesday'],
    location: { lat: 24.7136, lng: 46.6753 },
    credit: 15000,
    address: 'King Fahd Road, Riyadh',
    repId: '1',
  },
  {
    id: '2',
    name: 'Khaled Ali',
    phone: '0500000002',
    type: 'قطاعي',
    visitDays: ['Monday'],
    location: { lat: 24.7743, lng: 46.7386 },
    credit: 8500,
    address: 'Olaya Street, Riyadh',
    repId: '',
  },
];

function loadClients() {
  const json = localStorage.getItem(LOCAL_KEY);
  if (json) {
    try {
      return JSON.parse(json);
    } catch {
      return mockClients;
    }
  }
  return mockClients;
}
function saveClients(clients) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(clients));
}

const initialState = {
  clients: loadClients(),
  filtered: loadClients(),
  filters: {
    date: '',
    type: '',
    search: '',
  },
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
      let filtered = state.clients;
      const { date, type, search } = state.filters;
      if (date) {
        filtered = filtered.filter(client => client.visitDays.includes(date));
      }
      if (type) {
        filtered = filtered.filter(client => client.type === type);
      }
      if (search) {
        const s = search.toLowerCase();
        filtered = filtered.filter(client => client.name.toLowerCase().includes(s) || client.phone.includes(s));
      }
      state.filtered = filtered;
    },
    resetFilters(state) {
      state.filters = { date: '', type: '', search: '' };
      state.filtered = state.clients;
    },
    addClient(state, action) {
      state.clients.push(action.payload);
      state.filtered = state.clients;
      saveClients(state.clients);
    },
    removeClient(state, action) {
      state.clients = state.clients.filter(c => c.id !== action.payload);
      state.filtered = state.clients;
      saveClients(state.clients);
    },
    editClient(state, action) {
      const idx = state.clients.findIndex(c => c.id === action.payload.id);
      if (idx !== -1) {
        state.clients[idx] = action.payload;
        state.filtered = state.clients;
        saveClients(state.clients);
      }
    },
  },
});

export const { setFilter, resetFilters, addClient, removeClient, editClient } = clientsSlice.actions;
export default clientsSlice.reducer;

export const selectClientsByRep = (repId) => (state) =>
  state.clients.clients.filter(client => client.repId === repId); 